import { PricingCopilotMatrixOverviewSuggestion } from './pricing-copilot-matrix-overview-suggestion';
import { CustomRfqSession } from './rfq-session-custom';
import { SupplierDashboardOverviewTodaySnapshot } from './supplier-dashboard-overview-today-snapshot';

export class SupplierDashboardOverview {
	public closingSessions: CustomRfqSession[];
	public newestSessions: CustomRfqSession[];
	public pricingCopilotSuggestion: PricingCopilotMatrixOverviewSuggestion;
	public pinnedSessions: CustomRfqSession[];
	public todaySnapshot: SupplierDashboardOverviewTodaySnapshot;

	constructor(supplierDashboardOverview: SupplierDashboardOverview) {
		Object.assign(this, supplierDashboardOverview);

		this.closingSessions = this.closingSessions.map(r => new CustomRfqSession(r, true));
		this.newestSessions = this.newestSessions.map(r => new CustomRfqSession(r, true));
		this.pinnedSessions = this.pinnedSessions.map(r => new CustomRfqSession(r, true));
	}
}
